<!-- コース毎　検査項目マスタ　詳細画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style scoped>
	/* コース別検査項目があるレコード　* */
	.irkmListOn {
	}
	/* コース別検査項目がないレコード * */
	.irkmListOff {
			background-color: yellow
	}
	/* 編集中のレコード */ 
		.irkmListEdit {
				background-color: red
	}


</style>
<template>
	<div class="contents" id="wirks">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>コース毎　検査項目マスタ</h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>

				<!-- ▽  -->
				<section class="inputArea">
					<table class="inputTbl">
						<caption>
							<ul class="listClass">
								<li><b>クライアント名</b>{{jgnm}}</li>
								<li><b>年度</b>{{nend}}</li>
								<li><b>コース</b>{{ksnm}}</li>
							</ul>
							<div class="btnLst">
								<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
								<!-- ↑ contntMenu「戻る」に変更 <button class="cancelBtn" v-on:click="onCancel">キャンセル</button> -->
							</div>
						</caption>
						<thead>
							<tr>
								<th>項目名称</th>
								<td>受診対象</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(list, index) in listIrkm" v-bind:key="list.kmcd" v-bind:class="getClassNameByRecordStatuses(index)">
								<th>
									{{list.kmnm}}
								</th>
								<td>
									<ul class="radioLst">
										<li><label v-bind:for="getBindName('JskbAll',index)"  class="radio"><input type="radio" v-bind:id="getBindName('JskbAll',index)" v-bind:value="codeJskbAll" v-model="list.jskb" v-on:change="changeRecord(index)"><span>全員受診対象</span></label></li>
										<li><label v-bind:for="getBindName('JskbPart',index)" class="radio"><input type="radio" v-bind:id="getBindName('JskbPart',index)" v-bind:value="codeJskbPart" v-model="list.jskb" v-on:change="changeRecord(index)"><span>一部受診対象</span></label></li>
										<li><label v-bind:for="getBindName('JskbNo',index)"  class="radio"><input type="radio" v-bind:id="getBindName('JskbNo',index)" v-bind:value="codeJskbNo" v-model="list.jskb" v-on:change="changeRecord(index)"><span>受診対象外</span></label></li>
									</ul>
								</td>
							</tr>
						</tbody>
					</table>
					<!--データが一件もない場合に表示-->
					<div v-if="listIrkm.length == 0">
						<p>データが一件も登録されていません。</p>
					</div>
				</section>
				<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer">
				<a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WIRKMApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		// モジュール名
		name: 'MasterWIRKM',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			'errorMessageBox': ErrorMessageBox,
			// モーダルウィンドウ
			'modalWindow': ModalWindow,
		},
		// データ
		data() {
			return {
				// クライアント名
				jgnm: '',
				// 年度
				nend: 0,
				// コース名
				ksnm: '',
				// コース毎検査項目リスト
				// kmcd:検査項目コード
				// kmnm:検査項目名称
				// jskb:受診区分（1:全員、2:一部、9:受診対象外）
				// key:コースキー
				// recordStatus:レコードステータス
				// 0: WKKMM（検査項目マスタ）とWIRKM（コース毎検査項目マスタ）が
				//    ともに存在する
				// 1: WKKMM（検査項目マスタ）は存在するが
				//    WIRKM（コース毎検査項目マスタ）が存在しない
				// 12: WKKMM（検査項目マスタ）とWIRKM（コース毎検査項目マスタ）が
				//    ともに存在する時、
				//    画面でWIRKM（コース毎検査項目マスタ）を更新する場合
				// 13: WKKMM（検査項目マスタ）は存在するが
				//    WIRKM（コース毎検査項目マスタ）が存在しない時、
				//    画面でWIRKM（コース毎検査項目マスタ）を追加する場合
				listIrkm: [],
				codeJskbAll: '1',
				codeJskbPart: '2',
				codeJskbNo: '9',
				
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [''],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
							],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		// ライフサイクルハック　初期化
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWIRKM::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('MasterWIRKM::created End')
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog("MasterWIRKM::firstDisplay Start")

				// 非同期通信
				WIRKMApi.FirstDisplay({
					token: this.$store.state.auth.token,
					nend: this.$store.state.adminUserChoice.MasterWIRKS.nend,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd,
					kscd: this.$store.state.adminUserChoice.MasterWIRKS.kscd,
					key: this.$store.state.adminUserChoice.MasterWIRKS.key
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.jgnm = responce.data.jgnm
						this.nend = this.$store.state.adminUserChoice.MasterWIRKS.nend
						this.ksnm = responce.data.ksnm
						this.listIrkm = responce.data.listIrkm

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasetrWIRKM::firstDisplay End')
				})
			},
			// 更新確認ダイアログでOK押下時
			onUpdate: function () {
				UtilityConsoleLog.consoleLog("MasterWIRKM::onUpdate Start")

				WIRKMApi.Update({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					key: this.$store.state.adminUserChoice.MasterWIRKS.key,
					kmcds: this.getKmcds(),
					jskbs: this.getJskbs(),
					recordStatuses: this.getRecordStatuses()
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						//更新確認モーダルを閉じる
						this.onConfirmUpdateModalClose()
						// コース毎検査項目リスト再取得
						this.listIrkm = responce.data.listIrkm

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKM::onUpdate End')
				})
			},
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWIRKM::onCancel Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WIRKS_BACKTOLIST)

				this.$router.push("/MasterWIRKSList")

			  UtilityConsoleLog.consoleLog("MasterWIRKM::onCancel End")        
			},
			// 現在のkmcdを配列で返す
			getKmcds: function(){

				UtilityConsoleLog.consoleLog('MasterWIRKM::getKmcds Start')

				var resultKmcds = []

				for(var i=0;i<this.listIrkm.length;i++){
					resultKmcds.push(this.listIrkm[i].kmcd)
				}

				UtilityConsoleLog.consoleLog('MasterWIRKM::getKmcds End')

				return resultKmcds
			},
			// 現在のjskbを配列で返す
			getJskbs: function(){

				UtilityConsoleLog.consoleLog('MasterWIRKM::getJskbs Start')

				var resultJskbs = []

				for(var i=0;i<this.listIrkm.length;i++){
					resultJskbs.push(this.listIrkm[i].jskb)
				}

				UtilityConsoleLog.consoleLog('MasterWIRKM::getJskbs End')

				return resultJskbs
			},
			// 現在のrecordStatusを配列で返す
			getRecordStatuses: function(){

				UtilityConsoleLog.consoleLog('MasterWIRKM::getRecordStatuses Start')

				var resultRecordStatuses = []

				for(var i=0;i<this.listIrkm.length;i++){
					resultRecordStatuses.push(this.listIrkm[i].recordStatus)
				}

				UtilityConsoleLog.consoleLog('MasterWIRKM::getRecordStatuses End')

				return resultRecordStatuses
			},
			// レコードに変更があったとき
			changeRecord: function(index) {
				UtilityConsoleLog.consoleLog('MasterWIRKM::changeRecord Start')

				if('0' == this.listIrkm[index].recordStatus) {
					this.listIrkm[index].recordStatus = '12'
				} else if('1' == this.listIrkm[index].recordStatus) {
					this.listIrkm[index].recordStatus = '13'
				}

				UtilityConsoleLog.consoleLog('MasterWIRKM::changeRecord End')
			},
			// recordStatusによってクラスを設定する
			getClassNameByRecordStatuses: function(index) {
				
				var resultClassName = ''
				
				if('0' == this.listIrkm[index].recordStatus) {
					resultClassName = 'irkmListOn'
				} else if ('1' == this.listIrkm[index].recordStatus) {
					resultClassName = 'irkmListOff'
				} else if ('12' == this.listIrkm[index].recordStatus
										|| '13' == this.listIrkm[index].recordStatus) {
					resultClassName = 'irkmListEdit'
				}

				return resultClassName
			},
			// ラジオボタン用　for、name、idに名前割り当て
			getBindName: function(in_for,index){
				return in_for + String(index)
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWIRKM::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWIRKM::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKM::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWIRKM::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKM::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWIRKM::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKM::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push('/AdminLogin')

				UtilityConsoleLog.consoleLog('MasterWIRKM::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKM::onConfirmUpdateModalOpen Start')

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWIRKM::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKM::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWIRKM::onConfirmUpdateModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWIRKM::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWIRKM::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWIRKM::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWIRKM::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKS/MasterWIRKM.vue